<template>
  <div class="mb-12 control">
    <label class="label" for="funders"
      >Project funder(s) <span title="(this field is required)">*</span></label
    >
    <div class="mb-3 text-base caption trim">
      Please select who has provided funding for this project. If the funder you wish to add is not
      listed please <a :href="`mailto:${emailAddress}`">email us</a>
    </div>
    <multiselect
      id="funders"
      v-model="selected"
      :clear-on-select="true"
      :close-on-select="false"
      :hide-selected="true"
      :internal-search="false"
      :limit-text="limitText"
      :limit="3"
      :loading="isLoading"
      :max-height="600"
      :multiple="true"
      :options-limit="300"
      :options="options"
      :searchable="true"
      label="title"
      open-direction="bottom"
      placeholder="Type to search funders"
      track-by="title"
      @search-change="asyncSearchFunders"
    >
      <template slot="tag" slot-scope="{ option, remove }">
        <span class="multiselect__tag">
          <span>{{ option.title }}</span>
          <button
            type="button"
            class="multiselect__remove"
            title="remove option"
            @click="remove(option)"
          >
            ×
          </button>
        </span>
      </template>
      <template slot="clear" slot-scope="props">
        <div
          v-if="selected.length"
          class="multiselect__clear"
          @mousedown.prevent.stop="clearAll(props.search)"
        ></div>
      </template>
      <span slot="noResult">No matches found</span>
      <span slot="noOptions">
        <template v-if="!query">
          Please enter a search query
        </template>
      </span>
    </multiselect>
    <hidden-form-output :funders="selected" :name="name" />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

import HiddenFormOutput from "./HiddenFormOutput.vue";

import { ajaxFindFunders } from "./fundersApi";

export default {
  components: {
    Multiselect,
    HiddenFormOutput,
  },
  props: {
    urls: {
      type: Object,
      required: true,
    },
    emailAddress: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    initialValue: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      query: "",
      minQueryLength: 1,
      selected: [],
      options: [],
      isLoading: false,
    };
  },
  created() {
    this.selected = [...this.initialValue];
  },
  methods: {
    limitText(count) {
      return `and ${count} other funders`;
    },
    async asyncSearchFunders(query) {
      this.query = query;

      if (query.length >= this.minQueryLength) {
        this.isLoading = true;
        this.options = [];
        this.options = await ajaxFindFunders({ query, url: this.urls.all });
        this.isLoading = false;
      }
    },
    clearAll() {
      this.selected = [];
    },
  },
};
</script>
